import React from "react";
import { NumberInputSaveOnChange } from "./NumberInputSaveOnChange";
import { NumberInputWithClickOutside } from "./NumberInputWithClickOutside";

type NumberInputProps = {
  initialValue: number;
  onSave: (n: number) => void;
  allowOutsidePropagation?: boolean;
  min: number;
  max: number;
  disabled?: boolean;
  onClickOutside?: () => void;
  classNames?: string;
  updateOnChange?: boolean;
  testId?: string;
};

export const NumberInput = ({
  initialValue,
  onSave,
  allowOutsidePropagation = true,
  min = 0,
  max,
  disabled = false,
  onClickOutside = () => {},
  classNames = "",
  updateOnChange = false,
  testId = "number-input",
}: NumberInputProps) => {
  if (updateOnChange) {
    return (
      <NumberInputSaveOnChange
        initialValue={initialValue}
        onSave={onSave}
        min={min}
        max={max}
        disabled={disabled as boolean}
        classNames={classNames as string}
        testId={testId}
      />
    );
  }

  return (
    <NumberInputWithClickOutside
      initialValue={initialValue}
      onSave={onSave}
      allowOutsidePropagation={allowOutsidePropagation}
      min={min}
      max={max}
      disabled={disabled as boolean}
      onClickOutside={onClickOutside}
      classNames={classNames as string}
      testId={testId}
    />
  );
};
